// extracted by mini-css-extract-plugin
export default {"item":"styles_item__hufjy","content":"styles_content__WwvAx","social":"styles_social__ai4Zc"};